<p-editor
  [formControl]="control"
  [readonly]="readOnly() || disabled()"
  [pt]="{ content: { style: { height: height() } } }"
  [formats]="formats"
  (onTextChange)="textChange.emit($event)"
  (onBlur)="onTouched()"
>
  <ng-template #header>
    <span class="ql-formats">
      <select class="ql-header" aria-label="Heading">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option selected>Normal</option>
      </select>
    </span>
    <span class="ql-formats">
      <button class="ql-bold" type="button" aria-label="Bold"></button>
      <button class="ql-italic" type="button" aria-label="Italic"></button>
      <button
        class="ql-underline"
        type="button"
        aria-label="Underline"
      ></button>
    </span>
    <span class="ql-formats">
      <button
        class="ql-list"
        value="ordered"
        type="button"
        aria-label="Ordered List"
      ></button>
      <button
        class="ql-list"
        value="bullet"
        type="button"
        aria-label="Unordered List"
      ></button>
    </span>
    <span class="ql-formats">
      <button class="ql-link" type="button" aria-label="Insert Link"></button>
      <button class="ql-image" type="button" aria-label="Insert Image"></button>
      <button
        class="ql-code-block"
        type="button"
        aria-label="Insert Code Block"
      ></button>
    </span>
    <span class="ql-formats">
      <button
        class="ql-clean"
        type="button"
        aria-label="Remove Styles"
      ></button>
    </span>
  </ng-template>
</p-editor>
